import React, { useState, useEffect } from "react";
import { Table, Button, Modal } from "antd";
import { Select } from "@chakra-ui/react";
import axios from "axios";
import Cookies from "js-cookie";
import { firebaseAPI } from "../firebaseConfig";
import axiosInstance from "../utils/axiosInstance";

const UsersPage = () => {
  const [userData, setUserData] = useState([]);
  const [roleFilter, setRoleFilter] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(`${firebaseAPI}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUserData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const usersCSV = async () => {
    try {
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(`${firebaseAPI}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const users = response.data;
      const csvContent = users
        .map((user) => Object.values(user).join(","))
        .join("\n");
      const csvBlob = new Blob([csvContent], { type: "text/csv" });
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(csvBlob);
      downloadLink.download = "users.csv";
      downloadLink.click();
    } catch (error) {
      console.error("Error fetching or downloading participants:", error);
    }
  };

  const handleRoleFilterChange = (event) => {
    setRoleFilter(event.target.value);
  };

  const deleteUrUser = async (email) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Are you sure you want to remove this user?",
      onOk: async () => {
        try {
          let token = Cookies.get("token") || "";
          await axiosInstance.delete(`${firebaseAPI}/users?email=${email}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          fetchData();
        } catch (error) {
          console.error("Error deleting user:", error);
        }
      },
      onCancel: () => {},
      okText: "Yes",
      cancelText: "No",
    });
  };

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Remove User",
      key: "remove",
      render: (_, record) => (
        <Button
          style={{ backgroundColor: "#ff6882", color: "black" }}
          onClick={() => deleteUrUser(record.email)}
        >
          Remove User
        </Button>
      ),
    },
  ];

  const filteredData = roleFilter
    ? userData.filter((user) => user.role === roleFilter)
    : userData;

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ marginBottom: "20px" }}>Users List</h2>
      <Button onClick={usersCSV}>Export </Button>
      <Select
        placeholder="Select Role"
        value={roleFilter}
        onChange={handleRoleFilterChange}
        style={{ fontSize: "14px", padding: "4px" }}
        colorScheme="blue"
        color="white"
      >
        <option value="admin">Admin</option>
        <option value="participant">Participant</option>
        <option value="judge">Judge</option>
      </Select>
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="email"
        bordered
        pagination={{ pageSize: 10 }}
        style={{ borderRadius: "8px" }}
      />
    </div>
  );
};

export default UsersPage;
